export enum VipHousekeepingOverrideForms {
  CreateOverride = 'CreateOverride',
  UpdateOverride = 'UpdateOverride',
  DeleteOverride = 'DeleteOverride',
}
